import ComponentView from "./ComponentView";

const CreateComponentsView = ({
  originalGTMProject,
  components,
  suppliers,
}) => {
  return (
    <div className="text-sm">
      <div className="opacity-80">
        Components data auto populated from this project. Fill in the missing
        information and create them.
      </div>
      <div className="space-y-8 mt-4">
        {components.map((component, index) => (
          <ComponentView
            key={index}
            originalComponent={component}
            project={originalGTMProject}
            index={index}
            suppliers={suppliers}
          />
        ))}
      </div>
    </div>
  );
};

export default CreateComponentsView;
